import { render, staticRenderFns } from "./TeacherMembershipTable.vue?vue&type=template&id=7c835d2e&scoped=true&"
import script from "./TeacherMembershipTable.vue?vue&type=script&lang=js&"
export * from "./TeacherMembershipTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c835d2e",
  null
  
)

export default component.exports